module.exports = __webpack_public_path__ + "media/images/vp/mobileapps.ios-4fd42c5934083c482d9f7dd7e0fc24ad.svg";